import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2c5e7cba&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./styles/global.styl?vue&type=style&index=0&lang=stylus&"
import style1 from "./App.vue?vue&type=style&index=1&id=2c5e7cba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e7cba",
  null
  
)

component.options.__file = "App.vue"
export default component.exports